import React from 'react';
import List from 'material-ui/List';
import SearchResultsItemTop from './search_results_item_top.js';
import SearchResultsItem from './search_results_item.js';
import { withStyles } from 'material-ui/styles';

const styles = theme => ({
  results: {
  },
  noData: {
    textAlign: 'center',
    flex: 1,
  },
  flexGrow: {
    flex: '1 1 auto',
  },
});


class SearchResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    const classes = this.props.classes;

    if(this.props.results == null){
      return (
          <div/>
      );
    }

    if(this.props.results.errors){
      if(this.props.results.errors[0].domain === "usageLimits" && this.props.results.errors[0].message){
        return (
          <div className={classes.noData}>No more queries for today, usage limit reached</div>
        );        
      }
    }else if(this.props.results.items == null){
      return (
        <div className={classes.noData}>No results returned</div>
      );
    }

    if(this.props.type === 'card'){
      return this.renderCard();
    } else if (this.props.type === 'list'){
      return this.renderList();
    } else {
      return this.renderDiv();
    }
  }

  renderList(){
    const classes = this.props.classes;
    return (
      <div className={classes.results}>
        <List>
          { this.props.results &&
            this.props.results.items.map(item =>
              <SearchResultsItem key={item._id} type='list' item={item}></SearchResultsItem>
          )}
        </List>      
      </div>
    );
  }

  renderCard(){
    const classes = this.props.classes;
    return (
      <div className={classes.results}>
        {this.props.results &&
        this.props.results.items.map(item =>
          <SearchResultsItem key={item._id} type='card' item={item}></SearchResultsItem>
        )}
      </div>
    );
  }

  renderDiv(){
    const classes = this.props.classes;
    var key = 0;

    return (
      <div className={classes.results}>
        <SearchResultsItemTop results={this.props.results}/>
        {this.props.results && 
          this.props.results.items.map(item =>
            <SearchResultsItem key={key++} type='div' item={item} uiOptions={this.props.uiOptions} devMode={this.props.devMode} server={this.props.server}></SearchResultsItem>
        )}
      </div>
    );
  }

}

export default withStyles(styles)(SearchResults);


// WEBPACK FOOTER //
// ./src/search/search_results.js